import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TieredMenuModule} from 'primeng/tieredmenu';
import {PanelMenuModule} from 'primeng/panelmenu';
import {ReactiveFormsModule} from '@angular/forms';

import {
  NgZorroAntdModule,
  NzMenuBaseService,
  NzMenuItemDirective,
  NzMenuService,
  NzSubmenuService,
} from 'ng-zorro-antd';

import { MenuLateralComponent } from './menu-lateral.component';
import {PrevenirOverflowMenuDirective} from '../directiva/prevenir-overflow-menu.directive';

@NgModule({
  declarations: [
    MenuLateralComponent,
     PrevenirOverflowMenuDirective,
  ],
   imports: [
      CommonModule,
      TieredMenuModule,
      NgZorroAntdModule,
      PanelMenuModule,
     ReactiveFormsModule,
   ],
  providers: [
    NzSubmenuService,
    NzMenuService,
    NzMenuItemDirective,
    NzMenuBaseService,
  ],
  exports: [
    MenuLateralComponent,
     PrevenirOverflowMenuDirective,
  ]
})
export class MenuLateralModule { }
